/**
 * Subtrack returns `started_at` as a UTC wall-clock string without a timezone
 * suffix (e.g. `"2026-07-31 14:01:09"`). `Date` / `Date.parse` treat that as
 * local time, so elapsed time is skewed by the client offset.
 *
 * Same adjustment as the main-subscription fetch timeout in lpr-web:
 * `parsed.getTime() - getTimezoneOffset() * 60_000` recovers the UTC instant.
 */
export function parseSubscriptionStartedAtMs(startedAt: string): number {
  const parsed = new Date(startedAt).getTime()
  if (!Number.isFinite(parsed)) return NaN
  const timezoneOffsetMs = new Date().getTimezoneOffset() * 60 * 1000
  return parsed - timezoneOffsetMs
}
